<template>
  <v-dialog v-model="dialog" width="600px" persistent>
    <v-form @submit.prevent="handleSubmit()">
      <v-card :disabled="loading">
        <v-card-title>
          Cadastrar Produto
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="form.nome"
            label="Nome"
            :error-messages="validationErrors.nome"
            autofocus
          ></v-text-field>
          <v-text-field
            v-model="form.quantidade_total"
            type="number"
            label="Quantidade total"
            :error-messages="validationErrors.quantidade_total"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text>Cancelar</v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import api from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";

export default {
  mixins: [alerts],

  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        nome: "",
        quantidade_total: 0
      },
      validationErrors: {}
    };
  },

  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    reset() {
      this.form = {
        nome: "",
        quantidade_total: 0
      };

      this.validationErrors = {};
    },

    async handleSubmit() {
      this.validationErrors = {};
      this.loading = true;

      try {
        const product = await api.products.create(this.form);
        this.$emit("created", product);
        this.close();
      } catch (error) {
        if (error.response.status === 422) {
          this.validationErrors = error.response.data.errors;
          this.error("Corrija o formulário e tente novamente");
          return;
        }

        this.error("Não foi possível cadastrar produto");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
